"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var Url_To_Array = void 0;

Url_To_Array = function () {
    function Url_To_Array() {
        return window.location.href.split("/");
    }

    return Url_To_Array;
}();

exports.default = Url_To_Array();